const wallet = (state = {}, action) => {
    switch (action.type) {
        case "WALLET": {
            let user;
            user = action.payload

            return {
                price: user.wallet_price
            };
        }
        default: {
            return state
        }
    }
}

export default wallet;
